import React from 'react'

type Responsive = React.PropsWithChildren<{ className?: string }>

const ShowOnMobile = ({ className = '', children }: Responsive) => {
  return <div className={`block md:hidden ${className || ''}`}>{children}</div>
}

const ShowOnTablet = ({ className = '', children }: Responsive) => {
  return <div className={`block lg:hidden ${className || ''}`}>{children}</div>
}

const HideOnTablet = ({ className = '', children }: Responsive) => {
  return <div className={`hidden lg:block ${className || ''}`}>{children}</div>
}

const ShowOnDesktop = ({ className = '', children }: Responsive) => {
  return <div className={`hidden md:block ${className || ''}`}>{children}</div>
}
export { ShowOnMobile, ShowOnDesktop, ShowOnTablet, HideOnTablet }
